import * as service from './service'
export default {
  namespace: 'walletBankCard',
  state: {
    cardData: {},
    checkCardData: {},
    bindCardData: {}
  },
  effects: {
    * getBankCard ({ payload }, { call, put }) {
      const res = yield call(service.bankCard, payload)
      yield put({
        type: 'save',
        payload: {
          cardData: res.data.data
        }
      })
      return res.data
    },
    * checkBankCard ({ payload }, { call, put }) {
      const res = yield call(service.checkBankCard, payload)
      yield put({
        type: 'save',
        payload: {
          checkCardData: res.data
        }
      })
      return res.data
    },
    // * bindBankCard ({ payload }, { call, put }) {
    //   const res = yield call(service.bindBankCard, payload)
    //   yield put({
    //     type: 'save',
    //     payload: {
    //       bindCardData: res.data
    //     }
    //   })
    //   return res.data
    // },
    * addCourierBankCard ({ payload }, { call, put }) {
      const res = yield call(service.addCourierBankCard, payload)
      return res.data
    },
    * delCourierBankCard ({ payload }, { call, put }) {
      const res = yield call(service.delCourierBankCard, payload)
      return res
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
